export default "__VITE_ASSET__CWK_RNiO__"